import { usePullDownPage, PullPageContextProvider } from '@ssv-website/hooks';
import { ReactNode, Fragment } from 'react';

interface IPullDownPageProps {
  className?: string;
  url: string;
  renderItem(item: any, index: number): ReactNode;
  children?: React.ReactNode;
}

const RefreshLoading = () => {
  return (
    <div className="flex justify-center mt-20 text-primary fixed left-0 top-0 w-full">
      正在加载中。。。
    </div>
  );
};

const footerTexts = ['正在加载中。。。', '暂无更多数据', '下拉加载更多'];

const PullDownPageList: React.FC<IPullDownPageProps> = ({
  className,
  url,
  renderItem,
}) => {
  const { isLoading, data, size } = usePullDownPage(url);
  if (!data) return 'NO-DATA';
  return (
    <div className={`overflow-y-hidden  ${className || ''}`}>
      {isLoading && size === 1 && <RefreshLoading />}
      {(data || []).map((item: any, i: number) => (
        <Fragment>{renderItem(item, i)}</Fragment>
      ))}
      {/**下面是错误的 TODO */}
      <div>{isLoading && size !== 1 && footerTexts[0]}</div>
      <div>{!isLoading && size !== 1 && footerTexts[1]}</div>
      <div>{!isLoading && size !== 1 && footerTexts[1]}</div>
    </div>
  );
};

export const PullDownPage: React.FC<IPullDownPageProps> = (props) => {
  return (
    <PullPageContextProvider>
      <PullDownPageList {...props} />
    </PullPageContextProvider>
  );
};
